import { render, staticRenderFns } from "./FutureExchange.vue?vue&type=template&id=5ddf2e8b&scoped=true"
import script from "./FutureExchange.vue?vue&type=script&lang=js"
export * from "./FutureExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddf2e8b",
  null
  
)

export default component.exports